import { ReactElement } from 'react';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import { styled } from 'styled-components';

const Button = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledPlayIcon = styled(CaretRightOutlined)`
  font-size: 25px;
  cursor: pointer;
`;

const StyledPauseIcon = styled(PauseOutlined)`
  font-size: 25px;
  cursor: pointer;
`;

interface Props {
  isPlaying: boolean;
  onClick: () => void;
}

const PlayPauseButton = ({ isPlaying, onClick }: Props): ReactElement => (
  <Button onClick={onClick}>{isPlaying ? <StyledPauseIcon /> : <StyledPlayIcon />}</Button>
);

export default PlayPauseButton;
